

/**
 * 坡度分析
 * 规定：0°～0.5°为平原，>0.5°～2°为微斜坡，>2°～5°为缓斜坡，>5°～15°为斜坡，>15°～35°为陡坡，>35°～55°为峭坡，>55°～90°为垂直壁
 */

import DrawPolygon from "../plot/DrawPolygon"
import ConstantDraw from "../constants/ConstantDraw"
import { computeSurfacePoints } from "./utils/index"
import { computeSurfaceNormal, computeSlope } from "./utils/terrain"
import { cartesians2lonlats, lonlats2cartesians, lonlat2cartesian } from "./utils/geojson"
class SlopeAnalysis extends DrawPolygon {

    constructor(options) {
        super(options);
        this.options = options;
        this.sum = 0;
        this.entitiesLabel = [];
        this.centerPos = undefined;
        this.groundPrimitives = new Cesium.PrimitiveCollection();
        this.viewer.scene.primitives.add(this.groundPrimitives);
    }


    slopeColor(slope) {
        switch (true) {
            case slope >= 0 && slope <= 0.5:
                return Cesium.Color.GREEN;//""; // 平原
            case slope > 0.5 && slope <= 2:
                return Cesium.Color.GREEN;//""; // 微斜坡
            case slope > 2 && slope <= 5:
                return Cesium.Color.YELLOW;//""; // 缓斜坡
            case slope > 5 && slope <= 15:
                return Cesium.Color.ORANGE;  //""; // 斜坡
            case slope > 15 && slope <= 35:
                return Cesium.Color.RED;//""; // 陡坡
            case slope > 35 && slope <= 55:
                return Cesium.Color.PURPLE;//""; // 峭坡
            case slope > 55 && slope <= 90:
                return Cesium.Color.BROWN;//""; // 垂直壁
            default:
                console.log('无效的坡度值', slope);
                return Cesium.Color.BLACK//"black"; // 无效的坡度值
        }
    }



    initEditor() {
    }

    leftClick(evt) {
        super.leftClick(evt); //调用
        var $this = this;
        var l = $this.positions.length;
        var p = this.createPoint($this.positions[l-1], ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
    }
    rightClick(evt){
        var $this = this;
        var l = $this.positions.length;
        var end = $this.positions[l - 1];
        var p = this.createPoint(end, ConstantDraw.Style_KeyPos);
        this.entitiesLabel.push(p);
        super.rightClick(evt); //调用
    }

    reset() {
        super.reset();
        this.entitiesLabel = [];
    }

    initCenterPoint() {
        var keyPos = this.positions; //拿到关键点数组
        var posArr = this.cart2Wgs84(keyPos);
        var center = this.getCenter(posArr);
        var cart = Cesium.Cartesian3.fromDegrees(center[0], center[1]);
        this.centerPos = this.createPoint(cart);
        this.entities.push(this.centerPos);
    }
    leftDoubleClick(evt) {
        this.options.analysisStart();
        super.leftDoubleClick(evt);
        this.viewer.entities.remove(this.plot);
        for (var i = 0; i < this.entitiesLabel.length; i++) {
            this.viewer.entities.remove(this.entitiesLabel[i]);
        }
        this.computeSlope();
    }
    computeSlope() {
        var $this = this;

        var rectangle = Cesium.Rectangle.fromCartesianArray($this.positions);
        var west = rectangle.west;
        var south = rectangle.south;
        var east = rectangle.east;
        var north = rectangle.north;

        var bbox = [Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north), Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(south)];

        var distance = turf.distance([Cesium.Math.toDegrees(west), Cesium.Math.toDegrees(north)], [Cesium.Math.toDegrees(east), Cesium.Math.toDegrees(north)], { units: 'kilometers' });
        var cellSide = distance / 25; //固定数量
        var options = { units: 'kilometers' };
        var squareGrid = turf.squareGrid(bbox, cellSide, options);

        console.log(squareGrid);
        var features = squareGrid.features;
        var all_point = [];
        var center_all = [];
        for (let i = 0, len = features.length; i < len; i++) {
            var feature = features[i];
            var geometry = feature.geometry;
            var obj = $this.calPoint8(geometry.coordinates[0]);
            all_point.push(...obj.newArr);
            center_all.push(lonlat2cartesian(obj.center));
        }
        computeSurfacePoints({
            scene: this.viewer.scene,
            positions: lonlats2cartesians(all_point),
            has3dtiles: false,
            calback: (raisedPositions, noHeight) => {
                this.updateSlopeByMinHeight(raisedPositions, center_all);
                this.options.analysisDone();
            }
        });
    }

    //获取中心点八个方向坐标
    calPoint8(coordinates) {
        var newArr = [];
        newArr.push(coordinates[0]);
        newArr.push(this.getCenter([coordinates[0], coordinates[1]]));
        newArr.push(coordinates[1]);
        newArr.push(this.getCenter([coordinates[1], coordinates[2]]));
        newArr.push(coordinates[2]);
        newArr.push(this.getCenter([coordinates[2], coordinates[3]]));
        newArr.push(coordinates[3]);
        newArr.push(this.getCenter([coordinates[3], coordinates[4]]));
        return {
            newArr: newArr,
            center: this.getCenter([coordinates[0], coordinates[2]])
        };
    }
    //根据最低点计算坡度 
    updateSlopeByMinHeight(raisedPositions, center_all) {
        var $this = this;
        for (var i = 0, len = center_all.length; i < len; i++) {
            var center_cart = center_all[i];
            var lower = $this.findLowestP([raisedPositions[i * 8], raisedPositions[i * 8 + 1], raisedPositions[i * 8 + 2], raisedPositions[i * 8 + 3], raisedPositions[i * 8 + 4], raisedPositions[i * 8 + 5], raisedPositions[i * 8 + 6], raisedPositions[i * 8 + 7]]);
            //var style = ConstantDraw.Style_LineNor;
            //style.width = 20;
            //style.material = new Cesium.PolylineArrowMaterialProperty(Cesium.Color.YELLOW);

            //var normal_plan = computeSurfaceNormal(raisedPositions[i * 8], raisedPositions[i * 8 + 2], raisedPositions[i * 8 + 4]);
            //var angle= computeSlope(normal_plan,Cesium.Cartesian3.UNIT_Z);
            var obj = $this.findLowestHeight([raisedPositions[i * 8], raisedPositions[i * 8 + 1], raisedPositions[i * 8 + 2], raisedPositions[i * 8 + 3], raisedPositions[i * 8 + 4], raisedPositions[i * 8 + 5], raisedPositions[i * 8 + 6], raisedPositions[i * 8 + 7]]);
            //var angle = computeSlopeHeight(normal_plan, Cesium.Cartesian3.UNIT_Z);
            console.log(obj);
            const angle = Math.atan2(obj.h, obj.dis) * (180 / Math.PI);
            var color = $this.slopeColor(angle);
            $this.groundPrimitives.add(
                new Cesium.GroundPolylinePrimitive({
                    geometryInstances: new Cesium.GeometryInstance({
                        geometry: new Cesium.GroundPolylineGeometry({
                            positions: [center_cart, lower],
                            width: 10.0,
                        }),
                    }),
                    appearance: new Cesium.PolylineMaterialAppearance({
                        material: Cesium.Material.fromType(Cesium.Material.PolylineArrowType, {
                            color: color
                        })
                    }),
                })
            );
        }
    }

    clear() {
        super.clear();
        var $this = this;
        $this.groundPrimitives.removeAll();
        for (var i = 0; i < this.entitiesLabel.length; i++) {
            this.viewer.entities.remove(this.entitiesLabel[i]);
        }
    }

    //找到极限值
    findLowestHeight(arr) {
        var arrLonLat = cartesians2lonlats(arr);
        var min = arrLonLat[0][2];
        var minP = arrLonLat[0];

        var max = arrLonLat[0][2];
        var maxP = arrLonLat[0];
        for (let i = 0; i < arrLonLat.length; i++) {
            minP = min > arrLonLat[i][2] ? arrLonLat[i] : minP;
            min = minP[2];

            maxP = max < arrLonLat[i][2] ? arrLonLat[i] : maxP;
            max = maxP[2]
        }

        var dis = Cesium.Cartesian3.distance(Cesium.Cartesian3.fromDegrees(minP[0], minP[1], minP[2]), Cesium.Cartesian3.fromDegrees(maxP[0], maxP[1], minP[2]))
        return {
            min: minP,
            max: maxP,
            h: max - min,
            dis: dis
        }
    }

    //找到最低点
    findLowestP(arr) {
        var arrLonLat = cartesians2lonlats(arr);
        var min = arrLonLat[0][2];
        var minP = arrLonLat[0];
        for (let i = 0; i < arrLonLat.length; i++) {
            minP = min > arrLonLat[i][2] ? arrLonLat[i] : minP;
            min = minP[2]
        }
        return Cesium.Cartesian3.fromDegrees(minP[0], minP[1]);
    }

    cart2Wgs84(cartesain3Array) {
        let cartographics = Cesium.Ellipsoid.WGS84.cartesianArrayToCartographicArray(cartesain3Array);
        return cartographics.map(carto => {
            return [Cesium.Math.toDegrees(carto.longitude), Cesium.Math.toDegrees(carto.latitude)]
        })
    }

    //获取中心点
    getCenter(arr) {
        let centerLonLat = []
        if (arr.length) {
            const lon = []
            const lat = []
            const poly = [];
            for (let i = 0, len = arr.length; i < len; i++) {
                lon.push(arr[i][0])
                lat.push(arr[i][1])
            }
            for (let i = 0, len = lon.length; i < len; i++) {
                poly.push({
                    x: parseFloat(lon[i]),
                    y: parseFloat(lat[i]),
                    z: 0
                });
            }
            const sortedLongitudeArray = poly.map(item => item.x).sort();
            const sortedLatitudeArray = poly.map(item => item.y).sort();
            const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(14);
            const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(14);
            centerLonLat = [Number(centerLongitude), Number(centerLatitude)]
        }
        return centerLonLat;
    }

}

export default SlopeAnalysis